module.exports = __webpack_public_path__ + "img/layer-bg.4b90351e.png";